import syncApi from './syncApi';

/*
 * Product retirement client.
 *
 * Retirement unpublishes a SKU in Akeneo, deletes its BigCommerce product and
 * writes a permanent ledger row that keeps it out of every future push. The
 * destructive work runs as a single-stage `retire` job on the BigCommerce queue,
 * one job per market, so results show up on the jobs dashboard.
 *
 * `preview` is the safe way to size a run: it reports the effective action set
 * for the chosen environment plus any shared-bigcommerce_id conflicts whose
 * DELETE would be skipped.
 */

const base = '/products/retirement';

// Action codes must match waterco.product_retirement.ALL_ACTIONS.
export const ACTIONS = {
  BLOCK_BC: 'block_bc',
  AKENEO_UNPUBLISH: 'akeneo_unpublish',
  BC_DELETE: 'bc_delete',
  CLEAR_MAPPING: 'clear_mapping',
};

export const ACTION_LABELS = {
  [ACTIONS.BLOCK_BC]: 'Do not publish to BigCommerce',
  [ACTIONS.AKENEO_UNPUBLISH]: 'Do not publish in Akeneo',
  [ACTIONS.BC_DELETE]: 'Delete the product out of BigCommerce',
  [ACTIONS.CLEAR_MAPPING]: 'Clear the stored BigCommerce id',
};

export const ACTION_HINTS = {
  [ACTIONS.BLOCK_BC]:
    'Writes the retirement ledger row. This is what actually keeps the SKU out of future syncs.',
  [ACTIONS.AKENEO_UNPUBLISH]:
    'Sets Publish and WebEnabled to false for the selected markets scope, so Akeneo agrees.',
  [ACTIONS.BC_DELETE]:
    'Irreversible. URL slugs, reviews and inbound links on the listing are lost.',
  [ACTIONS.CLEAR_MAPPING]:
    'Drops the cached SKU to BigCommerce id pointer for this environment.',
};

export const getCandidates = (params) =>
  syncApi.get(`${base}/candidates`, { params }).then((r) => r.data);

export const previewRetirement = (payload) =>
  syncApi.post(`${base}/preview`, payload).then((r) => r.data);

export const createRetirementJobs = (payload) =>
  syncApi.post(`${base}/jobs`, payload).then((r) => r.data);

export const getRetired = (params) =>
  syncApi.get(`${base}/retired`, { params }).then((r) => r.data);

// `market` is optional and meaningful: omitting it clears only the all-markets
// ('*') ledger row, it does not un-retire every market.
export const unretire = (sku, market) =>
  syncApi
    .delete(`${base}/retired/${encodeURIComponent(sku)}`, {
      params: market ? { market } : {},
    })
    .then((r) => r.data);
